module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1f.a6941a26.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-1-1f.mp3
// module id = 506
// module chunks = 0